/**
 * prod
 * 873271646439 张宏光
 * 653159735340 李艳超18502201983
 * 346585654786 房玉博
 * 256472279 李艳超18002132991
 * 190193346216 15110040839翁浩然
 * 27892950 18400000002
 * 625462569748 宫朝渊
 * 20997611 成彩虹
 * 098973698362 高贺
 * 137455882 admin
 * 361270142709 陈希
 */

const uid_data = {
  test: {
    trunkRoad_autoTrace: [
      '245290638',
      '280044285', //18400000003
      '859718553269', //房玉博
      '137455882', //admin
    ],
    sattlement_receivable: [
      '245290638',
      '27892950', //18400000002
      '859718553269', //房玉博
      '137455882', //admin
    ],
    sattlement_payable: [
      '245290638', //18400000001
      '27892950',
      '859718553269', //房玉博
      '137455882', //admin
    ],
    allow_orderDetail_preDetail: [
      '245290638', //18400000001
      '859718553269', //房玉博
      '137455882', //admin
    ],
    // 报价价格是否ok操作
    allow_askBidList_priceSure: [
      '245290638', //18400000001
      '859718553269', //房玉博
      '137455882', //admin
    ],
    allow_orderDetail_total: [
      '245290638',
      '488146086931', //15934115579
      '859718553269', //房玉博
      '137455882', //admin
      '20997611',
    ],
    allow_order_cli_edit: [
      '245290638',
      '859718553269', //房玉博
      '137455882', //admin
    ],
    // 23.7.20新加权限
    business: [
      //应收应付列表的导出，导入，编辑
      '245290638', //18400000001
      '859718553269', //房玉博
      '137455882', //admin
    ],
    client_block: [
      //客户资源池/客户信息管理/客户信息管理审核
      // "27892950", //18400000002
      '245290638',
      '859718553269', //房玉博
      '137455882', //admin
    ],
    client_block_infoVerify: [
      '27892950',
      '137455882', //admin
    ],
    insurance_page: [
      //保险页面
      '280044285', //18400000003
      '245290638',
      '241109654',
      '859718553269', //房玉博
      '137455882', //admin
    ],
    allow_orderPay_price_change: [
      '280044285',
      '859718553269', //房玉博
      '137455882', //admin
    ],
    // 询价列表和自动报价列表导出
    ask_dataout_button: [
      '27892950', //18400000002
      '859718553269', //房玉博
      '137455882', //admin
    ],
    order_list_bidtype_change: [
      '27892950', //18400000002
      '859718553269', //房玉博
      '137455882', //admin
    ],
    change_task: [
      '27892950',
      '137455882', //admin
      '859718553269', //房玉博
    ],
    allow_multi_change_price: [
      '27892950',
      '137455882', //admin
      '859718553269', //房玉博
    ],
    binding_change_customer: [
      '27892950', //18400000002
      '859718553269', //房玉博
      '137455882', //admin
    ],
    edit_purchase_order_price: [
      '27892950', //18400000002
      '859718553269', //房玉博
    ],
    field_edit: [
      '137455882', //admin
    ],
    suplier_edit: [
      '137455882', //admin
    ],
  },
  prod: {
    // "" 小祥测试
    // "241109654" admin
    trunkRoad_autoTrace: [
      //允许看报价计算页面
      '361270142709', //陈希
      '241109654', //admin
      '346585654786', //房玉博
      '190193346216', //15110040839张贺嘉
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '625462569748', //宫朝渊
      '098973698362', //高贺
      '20997611',
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    sattlement_receivable: [
      //允许看应收页面(财务)
      '361270142709', //陈希
      '241109654', //admin
      '346585654786', //房玉博
      '190193346216', //15110040839张贺嘉
      '098973698362', //高贺
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '41612004', //刘志军
      '318855531', //刘庆怡
      '261022476637734', //郭晴
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    sattlement_payable: [
      //允许看应付页面(财务，服务中心)
      //其他可以看应付
      '361270142709', //陈希
      '241109654', //admin
      '346585654786', //房玉博
      '190193346216', //15110040839张贺嘉
      '098973698362', //高贺
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '41612004', //刘志军
      '318855531', //刘庆怡
      '261022476637734', //郭晴
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    //询价详情其他用户只能看总价
    allow_orderDetail_preDetail: [
      //允许看询价详情基础报价(提干送，服务中心)
      '241109654', //admin
      '346585654786', //房玉博
      '256472279', //李艳超18002132991
      '653159735340', //李艳超18502201983
      '361270142709', //陈希
      '625462569748', //宫朝渊
      '098973698362', //高贺
      '20997611', //成彩虹
      '190193346216', //15110040839张贺嘉
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '41612004', //刘志军
      '318855531', //刘庆怡
      '261022476637734', //郭晴
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    // 报价价格是否ok操作
    allow_askBidList_priceSure: [
      '241109654', //admin
      '346585654786', //房玉博
      '27892950', //18400000002
      '361270142709', //陈希
      '625462569748', //宫朝渊
      '098973698362', //高贺
      '190193346216', //15110040839张贺嘉
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    allow_orderDetail_total: [
      //允许看询价详情全部报价(客服)
      '361270142709', //陈希
      '241109654', //admin
      '346585654786', //房玉博
      '256472279', //李艳超18002132991
      '653159735340', //李艳超18502201983
      '20997611', //成彩虹
      '190193346216', //15110040839张贺嘉
      '098973698362', //高贺
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    //23.7.20新加权限限制
    business: [
      //应收应付列表的导出，导入，编辑
      '241109654', //admin
      '346585654786', //房玉博
      '361270142709', //陈希
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    client_block: [
      //客户资源池/客户信息管理
      '256472279', //李艳超18002132991
      '653159735340', //李艳超18502201983
      '361270142709', //陈希
      '241109654', //admin
      '346585654786', //房玉博
      '20997611', //成彩虹
      '190193346216', //15110040839张贺嘉
      '098973698362', //高贺
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    client_block_infoVerify: [
      //客户信息管理审核
      '346585654786', //房玉博
      '256472279', //李艳超18002132991
      '361270142709', //陈希
      '653159735340', //李艳超18502201983
      '241109654', //admin
      '20997611', //成彩虹
      '190193346216', //15110040839张贺嘉
      '098973698362', //高贺
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    insurance_page: [
      //保险页面
      '361270142709', //陈希
      '241109654', //admin
      '346585654786', //房玉博
      '20997611', //成彩虹
      '41612004', //刘志军
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    allow_order_cli_edit: [
      //允许订单列表修改客户名称
      '241109654', //admin
      '346585654786', //房玉博
      '361270142709', //陈希
      '20997611', //成彩虹
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    allow_orderPay_price_change: [
      //允许运费结算跟踪改价
      '256472279', //李艳超18002132991
      '653159735340', //李艳超18502201983
      '241109654', //admin
      '346585654786', //房玉博
      '361270142709', //陈希
      '20997611', //成彩虹
      '190193346216', //15110040839张贺嘉
      '098973698362', //高贺
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    // 询价列表和自动报价列表导出
    ask_dataout_button: [
      '241109654', //admin
      '346585654786', //房玉博
      '361270142709', //陈希
      '20997611', //成彩虹
      '190193346216', //15110040839张贺嘉
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    order_list_bidtype_change: [
      //订单列表修改报价类型
      '346585654786', //房玉博
      '241109654', //admin
      '361270142709', //陈希
      '190193346216', //15110040839张贺嘉
      '098973698362', //高贺
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '098973698362', //高贺
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    change_task: [
      //异常业务
      '346585654786', //房玉博
      '20997611', //成彩虹
      '241109654', //admin
      '361270142709', //陈希
      '190193346216', //15110040839张贺嘉
      '098973698362', //高贺
      '256472279', //李艳超18002132991
      '653159735340', //李艳超18502201983
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    //允许批量修改 应收应付价格
    allow_multi_change_price: [
      '241109654', //admin
      '346585654786', //房玉博
      '256472279', //李艳超18002132991
      '653159735340', //李艳超18502201983
      '20997611', //成彩虹
      '190193346216', //15110040839张贺嘉
      '098973698362', //高贺
      '361270142709', //陈希
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    //客户信息管理代下单业务员变更
    binding_change_customer: [
      '241109654', //admin
      '346585654786', //房玉博
      '20997611', //成彩虹
      '361270142709', //陈希
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    edit_purchase_order_price: [
      //子订单列表编辑价格
      '241109654', //admin
      '346585654786', //房玉博
      '190193346216', //15110040839张贺嘉
      '098973698362', //高贺
      '361270142709', //陈希
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '20997611', //成彩虹
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    field_edit: [
      //物流场地改场地名称/详细地址/GPS
      '190193346216', //15110040839张贺嘉
      '098973698362', //高贺
      '241109654', //admin
      '346585654786', //房玉博
      '361270142709', //陈希
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
    suplier_edit: [
      //承运商管理编辑
      '190193346216', //15110040839张贺嘉
      '098973698362', //高贺
      '241109654', //admin
      '346585654786', //房玉博
      '361270142709', //陈希
      '873271646439', //张宏光
      '494400994449', //吕尚奕
      '432872300839', //逯晓累
      '273118972553', //郭强
    ],
  },
} as any;

export const uid_auth = function (dev: string = 'test', uid: string): string[] {
  if (!uid) return [];
  let data = uid_data[dev];
  if (!data) data = dev == 'prod' ? uid_data['prod'] : uid_data['test'];

  const auth = [];
  const auth_keys = Object.keys(data) as string[];
  const auth_values = Object.values(data) as string[][];
  for (let i = 0; i < auth_values.length; i++) {
    const flag = auth_values[i].some((item) => item === uid);
    if (flag) auth.push(auth_keys[i]);
  }
  return auth;
};
